"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiffMockPlugin = void 0;
var init_1 = require("./api/init");
var shared_1 = require("./shared");
var set_1 = require("./api/set");
var clear_1 = require("./api/clear");
var LiffMockPlugin = /** @class */ (function () {
    function LiffMockPlugin() {
        this.name = 'mock';
    }
    LiffMockPlugin.prototype.install = function (_a) {
        var liff = _a.liff;
        var originalInit = liff.init;
        var isInClient = liff.isInClient();
        var mockedInit = (0, init_1.createMockedInit)(function (mockedLiff) {
            Object.entries(mockedLiff).forEach(function (_a) {
                var key = _a[0], value = _a[1];
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                liff[key] = value;
            });
        }, isInClient);
        liff.init = (0, shared_1.getActualInitOrMockedInit)(originalInit, mockedInit);
        return {
            set: set_1.set,
            clear: clear_1.clear,
        };
    };
    return LiffMockPlugin;
}());
exports.LiffMockPlugin = LiffMockPlugin;
